jQuery(document).ready(function($) {
  var current_size = $(window).width();
  var current_screen = '';
        if (current_size > 1023) {
          current_screen = 'desk';
          // alert(current_screen );
        } else if (current_size > 767 && current_size < 1024) {
          current_screen = 'tablet';
        } else {
          current_screen = 'mobile';
        }
        function screenChange() {
                var new_size = $(window).width();
                var new_screen = '';
                if (new_size > 1023) {
                  new_screen = 'desk';
                } else if (new_size > 767 && new_size < 1024) {
                  new_screen = 'tablet';
                } else {
                  new_screen = 'mobile';
                }
                if (new_screen == current_screen) {
                  return false;
                } else {
                  current_screen = new_screen;
                  current_size = new_size;
                  return true;
                }
              }
              if (current_size <= 1024) {
                // if()
          		$('.site-content .entry-content .second-level-menu .second-menu .current_page_item').appendTo('.second-level-menu .current-page-item');
          		}
      	$(window).resize(function(){
          if(screenChange()){
            if(current_screen == "desk"){
              $('.second-level-menu .current-page-item .current_page_item').prependTo('.site-content .entry-content .second-level-menu .second-menu');
              $('.site-content .entry-content .second-level-menu .second-menu').show();
            }
            else if(current_screen == "tablet"){
              $('.site-content .entry-content .second-level-menu .second-menu .current_page_item').appendTo('.second-level-menu .current-page-item');
            }
          }
        });

      // $('.site-content .entry-content .second-level-menu .current-page-item >li a').click(function( event ){
      //   event.preventDefault();
      // });

      $('.site-content .entry-content .second-level-menu .current-page-item').click(function(){
        $('.site-content .entry-content .second-level-menu .second-menu').slideToggle();
      })



  //add a table-wrapper for all tables in contet area
  $('.editor-content table').wrap('<div class="table-wrapper"></div>')

})
